import React, {useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import "./scss/global.scss";
import Cookies from "js-cookie";

// Component
// =================================================
import { Footer } from "./components";

// Pages
// ==================================================
import { Homepage, Search, About, Team, Services, ServiceDetails, ContactUs, Clients, Projects, ProjectDetails, Notfound } from "./pages";
import {
  useDispatch, useSelector
} from 'react-redux'
import {
  loadGlobalData
} from './store/slices/global'
import useLocale from './hooks/useLocale'
import { injectGTM } from './utils/gtm'

const App = () => {
  const dispatch = useDispatch()
  const locale = useLocale()
  const gtmId = useSelector(state => state.global.data && state.global.data.settings && state.global.data.settings.gtmId)

  useEffect(() => {
    // Header/Footer/glossary are shared chrome, not one specific page's data,
    // so this is the one dispatch that still lives at App level (as a proper
    // effect, not the render-body dispatch this replaced). Re-fires on locale
    // switch since Header no longer full-page-reloads to pick up new content.
    dispatch(loadGlobalData(locale))
  }, [dispatch, locale]);

  useEffect(() => {
    // GTM container ID lives in Strapi (settings.gtmId), not a build-time env
    // var, so it's only available after global settings finish loading.
    injectGTM(gtmId)
  }, [gtmId]);

  return (
    <>
      <Switch>
        {/* Deliberate Cookies read: remembers the visitor's last language
            choice across visits so a bare "/" lands on the right locale. */}
        <Route exact path="/" render={() => <Redirect to={`/${(Cookies.get("locale") || "EN").toLowerCase()}`} />} />
        <Route exact path="/:locale(en|id)" component={Homepage} />
        <Route path="/:locale(en|id)/search" component={Search} />
        <Route path="/:locale(en|id)/about" component={About} />
        <Route path="/:locale(en|id)/team" component={Team} />
        <Route path="/:locale(en|id)/services" component={Services} />
        <Route path="/:locale(en|id)/service-details/:slug" component={ServiceDetails} />
        <Route path="/:locale(en|id)/contact" component={ContactUs} />
        <Route path="/:locale(en|id)/our-client" component={Clients} />
        <Route path="/:locale(en|id)/projects" component={Projects} />
        <Route path="/:locale(en|id)/project-details/:slug" component={ProjectDetails} />
        <Route component={Notfound} />
        {/* <Route name="storybook" path="/storybook" component={Storybook} /> */}
      </Switch>
      <Footer />
    </>
  );
};

export default App;
